@if(evaluationState === EvaluationState.InProgress){
  <p-tag [value]="l('::InProgress')" class="in-progress-tag" [rounded]="true"></p-tag>
} @else if (evaluationState === EvaluationState.Finished){
  <p-tag [value]="l('::Finished')" class="finished-tag" [rounded]="true"></p-tag>
} @else{
  <p-tag [value]="l('::Pending')" class="pending-tag" [rounded]="true"></p-tag>
}